import { motion } from "framer-motion";
import { Play, Pause, Loader2 } from "lucide-react";

export default function PlayButton({ status, onToggle }) {
  const playing = status === "playing";
  const loading = status === "loading";

  return (
    <div className="relative">
      <div
        className="absolute inset-0 -m-12 rounded-full bg-amber-300/40 blur-3xl"
        aria-hidden
      />
      {playing && (
        <>
          <motion.span
            aria-hidden
            className="absolute inset-0 rounded-full border border-sky-400/50"
            animate={{ scale: [1, 1.55], opacity: [0.6, 0] }}
            transition={{ duration: 2.4, repeat: Infinity, ease: "easeOut" }}
          />
          <motion.span
            aria-hidden
            className="absolute inset-0 rounded-full border border-sky-400/30"
            animate={{ scale: [1, 1.55], opacity: [0.45, 0] }}
            transition={{
              duration: 2.4,
              repeat: Infinity,
              ease: "easeOut",
              delay: 1.2,
            }}
          />
        </>
      )}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.93 }}
        transition={{ type: "spring", stiffness: 320, damping: 22 }}
        data-testid="play-button"
        aria-label={playing ? "Metti in pausa la radio" : "Ascolta la radio"}
        onClick={onToggle}
        className="relative w-24 h-24 sm:w-32 sm:h-32 rounded-full flex items-center justify-center bg-white/70 backdrop-blur-md border border-sky-200 hover:bg-white hover:border-sky-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/60 transition-colors duration-500 shadow-[0_12px_45px_rgba(2,132,199,0.25)]"
      >
        {loading ? (
          <Loader2 className="w-9 h-9 sm:w-11 sm:h-11 text-sky-500 animate-spin" />
        ) : playing ? (
          <Pause className="w-9 h-9 sm:w-11 sm:h-11 text-sky-600 fill-current" />
        ) : (
          <Play className="w-9 h-9 sm:w-11 sm:h-11 text-sky-600 fill-current ml-1.5" />
        )}
      </motion.button>
    </div>
  );
}
